<template>
    <div>
        <Header title="代理商信息"/>
        <div
            class="scrollerView"
            :style="{ height: (wrapperHeight - 120) + 'px' }"
        >
            <scroller
                :on-refresh="refresh"
                ref="infinite"
                class="scroller"
            >
                <div class="line">
                    <p>代理商头像</p>
                    <img src="" alt="">
                </div>
                <div class="line">
                    <p>上级分公司</p>
                    <input type="text" v-model="tConponty">
                </div>
                <div class="line">
                    <p>公司名称</p>
                    <input type="text" v-model="conponty">
                </div>
                <div class="line">
                    <p>社会信用代码</p>
                    <input type="text" v-model="code">
                </div>
                <div class="line">
                    <p>省市区</p>
                    <span>山东省-青岛市-黄岛区</span>
                </div>
            </scroller>
        </div>
        <div class="footer">保存</div>
    </div>
</template>

<script>
import Header from '@/components/Header'
export default {
    /** 组件挂载 */
    components: {
        'Header': Header,
    },
    /** 数据区 */
    data() {
        return {
            loading: false,
            wrapperHeight: 0, //屏幕高度 - 脚部
            tConponty: '投道科技有限公司',
            conponty: '投道科技有限公司',
            code: '2901920391',
            textarea: '祖籍山东，7岁启蒙，潜心学习40余年，扎根于传统文化，汲取经典，孜孜不倦，在易学、心理、相学、佛学、地理等方面拥有独特建树与心得。',
            dataSources: [],
        };
    },
    /** 挂载后 */
    mounted() {
        this.wrapperHeight = document.documentElement.clientHeight;
    },
    /** 方法 */
    methods: {
        onPressNav(router, query={}) {
            this.$router.push({path: '/'+router, query: query})
        },
        refresh() {
            this.requestData(true);
        },
        requestData(type) {

        }
    },
};
</script>

<style lang="less" scoped>
.scrollerView {
    position: relative;
    width: 100%;
}

.scroller {
    background: #F8F8F8;

    .line {
        margin: 5px 15px 0;
        padding: 0 10px;
        height: 50px;
        border-radius: 5px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;

        p {
            font-size: 15px;
            color: #333;
            line-height: 50px;
        }

        span {
            flex: 1;
            font-size: 15px;
            color: #666;
            text-align: right;
        }

        input {
            flex: 1;
            font-size: 15px;
            color: #666;
            text-align: right;
        }

        img {
            width: 36px;
            height: 36px;
            border-radius: 50%;
        }
    }
}

.footer {
    height: 40px;
    margin: 10px 15px;
    background: linear-gradient(225deg,#9cb2f4, #6472e8);
    border-radius: 3px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    color: #fff;
}
</style>